(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bircom-cozumlerimiz"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bircom-solution-cards'))customElements.define('bircom-solution-cards',class extends HTMLElement{
  connectedCallback(){this.frame=requestAnimationFrame(()=>this.setup());}
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.controller?.abort();}
  setup(){
    this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
    const cards=[...this.querySelectorAll('[data-card]')];
    const flip=(card,open,focus=true)=>{
      const front=card.querySelector('[data-open]'),back=card.querySelector('[data-back]');
      card.classList.toggle('is-open',open);front.setAttribute('aria-expanded',String(open));
      back.inert=!open;front.inert=open;
      if(open)back.removeAttribute('aria-hidden');else back.setAttribute('aria-hidden','true');
      if(focus)(open?card.querySelector('[data-close]'):front).focus({preventScroll:true});
    };
    cards.forEach(c=>flip(c,c.classList.contains('is-open'),false));this.classList.add('is-ready');
    this.addEventListener('click',e=>{const b=e.target.closest('[data-open],[data-close]');if(b)flip(b.closest('[data-card]'),b.hasAttribute('data-open'));},{signal});
    this.addEventListener('keydown',e=>{const c=e.target.closest('[data-card]');if(e.key==='Escape'&&c?.classList.contains('is-open')){e.preventDefault();flip(c,false);}},{signal});
    document.addEventListener('shopify:block:select',e=>{const c=cards.find(c=>c.dataset.blockId===e.detail?.blockId);if(c){flip(c,true,false);c.scrollIntoView({block:'start',behavior:'instant'});}},{signal});
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bircom-kariyer"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.bircom').forEach(function(root){
    if(root.dataset.bcInit) return;
    root.dataset.bcInit = '1';

    var ENDPOINT_URL = root.getAttribute('data-endpoint') || '';

    var form = root.querySelector('.bc-form');
    if(!form) return;
    var select = root.querySelector('select[name="position"]');
    var errEl = root.querySelector('.bc-err');
    var btn = root.querySelector('.bc-submitBtn');
    var success = root.querySelector('.bc-success');
    var btnLabel = btn ? btn.textContent : 'Başvuruyu gönder';

    // roller -> form pozisyonu seç + forma kaydır
    root.querySelectorAll('.bc-role').forEach(function(b){
      b.addEventListener('click', function(){
        if(select) select.value = b.getAttribute('data-position');
        var t = root.querySelector('.bc-apply-sec');
        if(t) t.scrollIntoView({behavior:'smooth'});
        setTimeout(function(){ var n = form.querySelector('[name="name"]'); if(n) n.focus(); }, 500);
      });
    });

    // dosya yükleme
    var drop = root.querySelector('.bc-drop');
    var cv = root.querySelector('.bc-cv');
    var filebox = root.querySelector('.bc-filebox');
    var fn = root.querySelector('.bc-fn');
    var fs = root.querySelector('.bc-fs');
    var MAX = 10*1024*1024;
    var chosen = null;

    function fmt(b){ return b<1024*1024 ? (b/1024).toFixed(0)+' KB' : (b/1024/1024).toFixed(1)+' MB'; }
    function showErr(m){ errEl.textContent=m; errEl.classList.add('bc-show'); }
    function clearErr(){ errEl.classList.remove('bc-show'); }
    function setFile(file){
      if(!file) return;
      var ok = /\.(pdf|docx?)$/i.test(file.name) || /pdf|word|document/.test(file.type);
      if(!ok){ showErr('Lütfen PDF, DOC veya DOCX yükle.'); return; }
      if(file.size>MAX){ showErr('Dosya 10 MB sınırını aşıyor.'); return; }
      chosen=file; fn.textContent=file.name; fs.textContent=fmt(file.size); filebox.classList.add('bc-show'); clearErr();
    }
    if(drop){
      drop.addEventListener('click', function(){ cv.click(); });
      drop.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); cv.click(); } });
      ['dragenter','dragover'].forEach(function(ev){ drop.addEventListener(ev, function(e){ e.preventDefault(); drop.classList.add('bc-over'); }); });
      ['dragleave','drop'].forEach(function(ev){ drop.addEventListener(ev, function(e){ e.preventDefault(); drop.classList.remove('bc-over'); }); });
      drop.addEventListener('drop', function(e){ var f=e.dataTransfer.files[0]; if(f){ cv.files=e.dataTransfer.files; setFile(f); } });
    }
    if(cv) cv.addEventListener('change', function(e){ setFile(e.target.files[0]); });
    var rm = root.querySelector('.bc-removeFile');
    if(rm) rm.addEventListener('click', function(){ chosen=null; cv.value=''; filebox.classList.remove('bc-show'); });

    function toBase64(file){ return new Promise(function(res,rej){ var r=new FileReader(); r.onload=function(){res(r.result.split(',')[1]);}; r.onerror=rej; r.readAsDataURL(file); }); }

    form.addEventListener('submit', function(e){
      e.preventDefault(); clearErr();
      var name=form.name.value.trim(), email=form.email.value.trim(), phone=form.phone.value.trim();
      if(!name||!email||!phone){ showErr('Lütfen ad, e-posta ve telefon alanlarını doldur.'); return; }
      if(!select.value){ showErr('Lütfen bir pozisyon seç.'); return; }
      if(!chosen){ showErr('Lütfen CV dosyanı yükle.'); return; }
      var kvkk = root.querySelector('.bc-kvkk');
      if(kvkk && !kvkk.checked){ showErr('Devam etmek için KVKK onayı gerekli.'); return; }

      btn.disabled=true; btn.textContent='Gönderiliyor…';
      toBase64(chosen).then(function(b64){
        var payload={
          name:name, email:email, phone:phone,
          linkedin:form.linkedin.value.trim(), position:select.value, message:form.message.value.trim(),
          filename:chosen.name, mimeType:chosen.type||'application/octet-stream',
          fileBase64:b64, submittedAt:new Date().toISOString()
        };
        var done = function(){
          form.style.display='none';
          success.classList.add('bc-show');
          success.scrollIntoView({behavior:'smooth',block:'center'});
        };
        if(ENDPOINT_URL){
          fetch(ENDPOINT_URL,{method:'POST',mode:'no-cors',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(payload)})
            .then(done).catch(function(){
              showErr('Gönderim sırasında bir sorun oldu. Lütfen tekrar dene.');
              btn.disabled=false; btn.textContent=btnLabel;
            });
        }else{
          setTimeout(done,700);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bircom-markalar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bircom-brand-cards')) {
    customElements.define('bircom-brand-cards', class extends HTMLElement {
      connectedCallback() { this.frame = requestAnimationFrame(() => this.setup()); }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); }
      setup() {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const cards = [...this.querySelectorAll('[data-card]')];
        const flip = (card, open, focus = true) => {
          const front = card.querySelector('[data-open]');
          const back = card.querySelector('[data-back]');
          card.classList.toggle('is-flipped', open);
          front.setAttribute('aria-expanded', String(open));
          back.inert = !open;
          if (open) back.removeAttribute('aria-hidden');
          front.inert = open;
          if (focus) (open ? card.querySelector('[data-close]') : front).focus({preventScroll: true});
          if (!open) back.setAttribute('aria-hidden', 'true');
        };
        cards.forEach(card => flip(card, card.classList.contains('is-flipped'), false));
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-open], [data-close]');
          if (!button) return;
          flip(button.closest('[data-card]'), button.hasAttribute('data-open'));
        }, {signal});
        this.addEventListener('keydown', event => {
          const card = event.target.closest('[data-card]');
          if (event.key === 'Escape' && card?.classList.contains('is-flipped')) { event.preventDefault(); flip(card, false); }
        }, {signal});
        const filterBar = this.querySelector('[data-filters]');
        const filterButtons = [...this.querySelectorAll('[data-filter]')];
        const validFilters = ['tumu', 'tuketici-elektronigi', 'kurumsal'];
        const readFilter = () => {
          const value = new URL(location.href).searchParams.get('kategori');
          return validFilters.includes(value) ? value : 'tumu';
        };
        const applyFilter = (value, updateUrl = false) => {
          const category = validFilters.includes(value) ? value : 'tumu';
          cards.forEach(card => {
            const visible = category === 'tumu' || card.dataset.category === category;
            if (!visible) flip(card, false, false);
            card.hidden = !visible;
          });
          filterButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
          this.querySelector('[data-filter-status]').textContent = `${cards.filter(card => !card.hidden).length} marka gösteriliyor.`;
          if (updateUrl) {
            const url = new URL(location.href);
            if (category === 'tumu') url.searchParams.delete('kategori');
            else url.searchParams.set('kategori', category);
            url.hash = '';
            if (url.href !== location.href) history.pushState(null, '', url.href);
          }
        };
        filterBar.hidden = false;
        applyFilter(readFilter());
        filterBar.addEventListener('click', event => {
          const button = event.target.closest('[data-filter]');
          if (button) applyFilter(button.dataset.filter, true);
        }, {signal});
        const reveal = card => {
          if (!card) return;
          if (card.hidden) applyFilter(card.dataset.category);
          flip(card, true);
          card.scrollIntoView({block: 'start', behavior: 'instant'});
        };
        const fromHash = () => {
          let id;
          try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
          reveal(cards.find(card => card.id === id));
        };
        window.addEventListener('hashchange', fromHash, {signal});
        document.addEventListener('shopify:block:select', event => reveal(cards.find(card => card.dataset.blockId === event.detail?.blockId)), {signal});
        window.addEventListener('popstate', () => { applyFilter(readFilter()); fromHash(); }, {signal});
        fromHash();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
